import { render, staticRenderFns } from "./MarketplaceReviewsModule.vue?vue&type=template&id=102ecbe8&scoped=true"
import script from "./MarketplaceReviewsModule.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ecbe8",
  null
  
)

export default component.exports